window.TabbedContentContainer = (initial_tab) => {
	return {
		active_tab: initial_tab,

		init() {
			//
		}
	};
};
